module.exports = __webpack_public_path__ + "img/1482462468.b3cbe848.jpg";